module.exports = __webpack_public_path__ + "img/newslater.f1045645.png";